import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import banner from '../../Images/img.png';
import { useDispatch, useSelector } from 'react-redux';
import { selectDeleteUserDetails, selectVerificationDetails } from './Selectors';
import { emailVerificationRequest } from './Actions';
import { useLocation, useNavigate } from 'react-router-dom';
import './style.css';
import { BodyTextHeadingSmall, ButtonText, HeaderText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const EmailVerification = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [fieldError, setFieldError] = useState({ fieldVerification: false });
    const [err, setErr] = useState(false);

    const emailVerification = useSelector(selectDeleteUserDetails);
    const verificationSuccess = useSelector(selectVerificationDetails);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    if(verificationSuccess || !emailVerification?.id) {
        navigate('/delete-account');
    }

    useEffect(() => {
        if(!emailVerification?.id) {
            const isReloaded = performance.getEntriesByType('navigation')[0].type === 'reload';
    
            if (isReloaded) {
            // Replace '/home' with your desired route
                if (location.pathname !== '/delete-account') {
                    navigate('/delete-account');
                }
            }
        }
    }, [navigate, location]);

    const onFinish = (values) => {
        const { verification } = values;
        
        if (!verification) {
            setFieldError({ fieldVerification: true });
            setErr(true);
            return;
        }

        if (emailVerification?.id) {
            const payload = {
                verification : verification,
                emailVerificationId : emailVerification.id
            };
            dispatch(emailVerificationRequest(payload));
            form.resetFields();
            setFieldError({ fieldVerification: false });
            setErr(false);
        } else {
            setErr(true);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Col
                xs={24}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                }}
            >
                <div
                    style={{
                        height: '100%',
                        width: '50%',
                        objectFit: 'contain',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <img
                        style={{ height: '100%', width: '50%' }}
                        src={banner}
                        alt="Banner"
                    />
                </div>
                <Card
                    style={{
                        width: '70%',
                        borderRadius: '8px',
                        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.18)',
                        borderTop: 'none',
                        margin: '10px',
                    }}
                >
                    <Row
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <div
                            style={{
                                fontWeight: 700,
                                color: '#1965a4',
                                fontSize: '36px',
                            }}
                        >
                            <HeaderText text = {langdata.VerifyAccount ? langdata.VerifyAccount : 'Verify Account'} color = '#1965a4' />
                        </div>
                        <p
                            style={{
                                fontWeight: 500,
                                color: '#000000',
                                fontSize: '20px',
                                marginTop: '15px',
                                width: '70%',
                                textAlign: 'center',
                            }}
                        >
                            <BodyTextHeadingSmall text =  {langdata.A4digitverificationcodehasbeensenttoyourregisteredemailaddress ? langdata.A4digitverificationcodehasbeensenttoyourregisteredemailaddress : 'A 4-digit verification code has been sent to your registered email address'} />
                        </p>
                        <Form
                            form={form}
                            onFinish={onFinish}
                            style={{ width: '70%' }}
                            layout="vertical"
                        >
                            <Form.Item
                                label={
                                    <h3>
                                        {langdata.Verificationcode ? langdata.Verificationcode : 'Verification code'}
                                    </h3>
                                }
                                name="verification"
                                rules={[
                                    {
                                        required: true,
                                        message: langdata.Pleaseenteryourverificationcode ? langdata.Pleaseenteryourverificationcode : 'Please enter your verification code',
                                    },
                                ]}
                            >
                                <Input
                                    type="number"
                                    placeholder={langdata.Verification ? langdata.Verification : 'Verification'}
                                    name="verification"
                                    size="large"
                                    className='reduce-form-label'
                                />
                            </Form.Item>
                            {fieldError.fieldVerification && (
                                <p style={{ fontSize: '12px', color: 'red' }}>
                                    {langdata.Pleasefillyourverificationcode ? langdata.Pleasefillyourverificationcode : 'Please fill your verification code' }
                                </p>
                            )}
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginTop: '20px',
                                }}
                            >
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{
                                        fontFamily: 'Roboto',
                                        fontSize: 'large',
                                    }}
                                    size="large"
                                >
                                    <ButtonText text = {langdata.Submit ? langdata.Submit : 'Submit'} />
                                </Button>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginTop: '5px',
                                }}
                            >
                                {err && (
                                    <h5 style={{ color: 'red' }}>
                                        {langdata.Pleasefillalltherequiredfields ? langdata.Pleasefillalltherequiredfields : 'Please fill all the required fields' }
                                    </h5>
                                )}
                            </div>
                        </Form>
                    </Row>
                    <Row
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '60px',
                        }}
                    />
                </Card>
            </Col>
        </div>
    );
};

export default EmailVerification;
